const logo = '/wp-content/uploads/2019/02/logo.png'

export {
    logo
}
